import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getLocaleSelector from 'store/app/selector/getLocaleSelector';
import { setLandingPageData } from 'store/landing/slice';

const fetchNoResultsContentOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const results = await apiRequest<any>(
      endpoints.searchV2Regular,
      {
        query: '',
        locale: getLocaleSelector(getState()),
        offset: 0,
        limit: 0,
        orderBy: '',
      },
      HttpMethods.POST,
      'data',
    );

    try {
      const fallbackContent = JSON.parse(results.fallbackContent);
      dispatch(setLandingPageData(fallbackContent));
    } catch (e) {
      console.error(e);
      dispatch(setLandingPageData(null));
    }
  };

export default fetchNoResultsContentOperation;
